import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private http: HttpService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log('en canActivate');

    const restrictedRoutes = [
      '/clientes',
      '/guardias',
      '/instalaciones',
      '/supervisores',
      '/rondas',
      // '/accesoscedulas',
      // '/home',
      '/chat',
      '/mapas',
      '/asistencia',
      '/asistenciaindiv',
      '/turnos',
      '/usuarios',
      '/soporte',
    ];

    const restrictedSoporteRoutes = [
      '/soporte',
    ];

    console.log('En auth.guard');
    console.log('url', state.url);

    const usuario = JSON.parse(this.http.getLocalstorage('usuario'))
    const userDataAdmin = JSON.parse(this.http.getLocalstorage('userDataAdmin'))

    if (!usuario) {
      this.router.navigateByUrl('login')
      return false
    }

    const tipoUsuario = usuario.TipoUsuario

    console.log('usuario', usuario);
    console.log('tipoUsuario', tipoUsuario);
    console.log('userDataAdmin', userDataAdmin);

    const exp = new Date(userDataAdmin.exp * 1000)

    if (exp < new Date()) {
      console.log('Expiró');
      this.router.navigateByUrl('login')
      return
    }

    if (tipoUsuario != 'SUPER') {
      console.log('zona restringida'); 
      this.router.navigateByUrl('login/true')
      return
    }


    return true;

  }

}
